
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class AdminRightsTooltip extends Vue {
  @Prop() private target!: string;
}
